export default [
  {
    name: 'overview',
    label: 'Overview',
    hideOnNavbar: true,
    component: () => import('./Steps/OverviewStep'),
    navigation: {
      back: null,
      next: { label: 'Next', to: 'setup' },
      skip: null,
    },
  },
  {
    name: 'setup',
    label: 'Setup',
    navbarIndex: 0,
    component: () => import('./Steps/SetupStep'),
    navigation: {
      back: { label: 'Back', to: 'overview' },
      next: { label: 'Next', to: 'availability' },
      skip: null,
    },
  },
  {
    name: 'availability',
    label: 'Availability',
    navbarIndex: 1,
    component: () => import('./Steps/AvailabilityStep'),
    navigation: {
      back: { label: 'Back', to: 'setup' },
      next: { label: 'Next', to: 'preview' },
      skip: null,
    },
  },
  {
    name: 'preview',
    label: 'Preview',
    navbarIndex: 2,
    component: () => import('./Steps/PreviewStep'),
    navigation: {
      back: { label: 'Back', to: 'availability' },
      finish: { label: 'Finish', to: null },
      skip: null,
    },
  },
]
